import React, { ReactNode } from 'react'
import FormHeader from '../form-header'
import style from './index.module.scss'

interface Props {
  title: string
  form: ReactNode
  toggleLoginSignup?: ReactNode
  intro?: ReactNode
  outro?: ReactNode
  socialLogins?: ReactNode
  footer?: ReactNode
}

const OnboardingForm: React.FC<Props> = (props) => (
  <>
    <FormHeader title={props.title} />
    {props.toggleLoginSignup}

    {props.intro}

    <div className={style.form}>{props.form}</div>
    {props.outro}
    {props.socialLogins}
    {props.footer}
  </>
)

export default OnboardingForm
